var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00001 2.33334C6.88917 2.33334 6.77834 2.37417 6.69084 2.46167L3.15001 6.0025C2.98084 6.17167 2.98084 6.45167 3.15001 6.62084C3.31917 6.79 3.59917 6.79 3.76834 6.62084L7.00001 3.38917L10.2317 6.62084C10.4008 6.79 10.6808 6.79 10.85 6.62084C11.0192 6.45167 11.0192 6.17167 10.85 6.0025L7.30917 2.46167C7.22167 2.37417 7.11084 2.33334 7.00001 2.33334Z",
    fill: "#7CAA74"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 2.43251C6.76083 2.43251 6.5625 2.63084 6.5625 2.87001V10.3542C6.5625 10.5933 6.76083 10.7917 7 10.7917C7.23917 10.7917 7.4375 10.5933 7.4375 10.3542V2.87001C7.4375 2.63084 7.23917 2.43251 7 2.43251Z",
    fill: "#7CAA74"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/up.1c34025c88059d216f36db75615b622f.svg";
export { ForwardRef as ReactComponent };